import React from 'react'
import { removalOf } from '../removal-words'
import { removedNotice } from './person-words'

// The removed member's notice card (owner 2026-10-29: one plain sentence and
// a tiny Restore): who removed them and when (removal-words, spec R25, with
// the sticky line), what removal means, and what brings them back. Restore
// itself is the page header's action, with its confirmation.
export const RemovedCard = ({ row, canRestore }) => {
  const removal = removalOf(row)
  const notice = removedNotice({ row, canRestore })
  return (
    <section className="sw-section pp-removed" aria-labelledby="pp-removed-title" data-testid="removed-card">
      <h2 className="h6 fw-semibold mb-1" id="pp-removed-title">Removed from this organization</h2>
      <p className="mb-3" data-testid="removed-member-text">
        {removal ? [removal.text, removal.sticky].filter(Boolean).join(' ') : 'They are no longer a member of this organization.'}
      </p>
      <div className="pp-removed-cols">
        <div>
          <h3 className="pp-h3">What this means</h3>
          <ul className="pp-list">
            {notice.means.map(line => <li key={line}>{line}</li>)}
          </ul>
        </div>
        <div>
          <h3 className="pp-h3">What brings them back</h3>
          <ul className="pp-list">
            {notice.back.map(line => <li key={line}>{line}</li>)}
          </ul>
        </div>
      </div>
    </section>
  )
}
